/******** cart specific functions ***start***/

var showTheseProps = ["Size", "Material", "Sides", "Artwork", "Finish", "Overlamination", "Foil Stamping", "Numbering", "Matte Varnish", "White Halo"];
var cartItems = {};
var cartItemRemoveIcon = "//stompstickers.com/cdn/shop/t/440/assets/cart_icon_close.svg?v=76220105522937642031722966974";
var noImage = "//stompstickers.com/cdn/shop/t/440/assets/no-image.gif?v=45522147725489476581722966974";
var _learnq = _learnq || [];

function displayLoader(display) {
  if (display) {
    $('.cart_block').addClass('hidden');
    $('.loader').removeClass('hidden');
  } else {
    $('.cart_block').removeClass('hidden');
    $('.loader').addClass('hidden');
  }
}

function fireKlaviyoCartEvent() {
  if (cart[Object.keys(cart)[0]]) {
    let firstCartItem = cart[Object.keys(cart)[0]];
    let propertyStringsArray = [];

    if (firstCartItem.properties) {
      propertyStringsArray = Object.entries(firstCartItem.properties).filter(item => {
        let properties = ["Size", "Material", '_thumbnail', '_thumbnail2', '_customer_canvas_state', '_print_ready_image', '_lot_pricing', '_Item Price', '_Unwind Direction', '_cloudinary_url', '_low_dpi', '_Custom Size', '_border', '_Numbering', '_parking-permit-starting-number', 'Sides', '_parking-permit-prefix', '_parking-permit-preview'];
        if (properties.indexOf(item[0]) > -1 || properties.indexOf(`_${item[0]}`) > -1) {
          return true
        }
        return false
      }).map(([key, value]) => {
        return `properties[${key.replace(/\s/g, '%20')}]=${value.replace(/\s/g, '%20').replaceAll('"', '%22').replaceAll("/", '%2F').replaceAll(":", '%3A').replaceAll(";", '%3B').replaceAll("=", '%3D').replaceAll("?", '%3F').replaceAll("@", '%40').replaceAll("&", '%26').replaceAll("+", '%2B').replaceAll("$", '%24').replaceAll(",", '%2C').replaceAll("#", '%23').replaceAll(".", "%2E")}`
      })
      propertyStringsArray = propertyStringsArray.join('&items[]')
    }



    // let createCartURLSize = firstCartItem.properties['Size'] ? `&properties[Size]=${firstCartItem.properties['Size'].replace(/\s/g, '%20')}` : '';
    // let createCartURLMaterial = firstCartItem.properties['Material'] ? `&properties[Material]=${firstCartItem.properties['Material'].replace(/\s/g, '%20')}` : '';
    // let createCartURLThumbnail = firstCartItem.properties['thumbnail'] ? `&properties[thumbnail]=${firstCartItem.properties['thumbnail'].replace(/\s/g, '%20')}` : '';
    // let createCartURLThumbnail2 = firstCartItem.properties['thumbnail2'] ? `&properties[thumbnail2]=${firstCartItem.properties['thumbnail2'].replace(/\s/g, '%20')}` : '';
    // let createCartURLCanvasState = firstCartItem.properties['customer_canvas_state'] ? `&properties[customer_canvas_state]=${firstCartItem.properties['customer_canvas_state'].replace(/\s/g, '%20')}` : '';
    // let createCartURLPrintImage = firstCartItem.properties['print_ready_image'] ? `&properties[print_ready_image]=${firstCartItem.properties['print_ready_image'].replace(/\s/g, '%20')}` : '';
    // let createCartURLLotPricing = firstCartItem.properties['_lot_pricing'] ? `&properties[_lot_pricing]=${firstCartItem.properties['_lot_pricing'].replace(/\s/g, '%20')}` : '';
    // let createCartURLItemPricing = firstCartItem.properties['_Item Price'] ? `&properties[_Item Price]=${firstCartItem.properties['_Item Price'].replace(/\s/g, '%20')}` : '';
    // let createCartURLUnwindDirection = firstCartItem.properties['Unwind Direction'] ? `&properties[Unwind Direction]=${firstCartItem.properties['Unwind Direction'].replace(/\s/g, '%20')}` : '';
    // let createCartURLCloudinaryURL = firstCartItem.properties['cloudinary_url'] ? `&properties[cloudinary_url]=${firstCartItem.properties['cloudinary_url'].replace(/\s/g, '%20')}` : '';
    // let createCartURLLowDPI = firstCartItem.properties['low_dpi'] ? `&properties[low_dpi]=${firstCartItem.properties['low_dpi'].replace(/\s/g, '%20')}` : '';
    // let createCartURLCustomSize = firstCartItem.properties['Custom Size'] ? `&properties[Custom Size]=${firstCartItem.properties['Custom Size'].replace(/\s/g, '%20')}` : '';
    // let createCartURLBorder = firstCartItem.properties['border'] ? `&properties[border]=${firstCartItem.properties['border'].replace(/\s/g, '%20')}` : '';

    let encodedURL = encodeURIComponent(`items[][id]=${firstCartItem.variant_id}&items[][quantity]=${firstCartItem.quantity}&items[]${propertyStringsArray}`);

    let createCartURL = `https://stompstickers.com/cart/clear?return_to=/cart/add?${encodedURL}`;

    let klaviyoCartObject = (({ product_title, final_line_price, quantity, handle, variant_id, properties }) => ({ product_title, final_line_price, quantity, handle, variant_id, properties }))(firstCartItem);

    klaviyoCartObject.createCartURL = createCartURL;

    setTimeout(() => {
      _learnq.push(["track", "Landed On Cart Page", klaviyoCartObject]);
    }, 100);
  }
}


function isItemAddOn(item) { // check if cart item is an addon
  return item.variant_id == overlamVariantId || item.variant_id == foilVariantId || item.variant_id == numberingVariantId || item.variant_id == matteVariantId;
}

function getCurrentAddOns() {
  var addons = {};
  for (var i = 0; i < cart.length; i++) {
    var item = cart[i];
    if (isItemAddOn(item)) {
      if (!isset(addons[item.variant_id])) {
        addons[item.variant_id] = {};
      }
      if (!isset(item.properties) || !isset(item.properties['_Item Price'])) {
        continue;
      }
      if (!isset(addons[item.variant_id][item.properties['_Item Price']])) {
        addons[item.variant_id][item.properties['_Item Price']] = 0;
      }
      addons[item.variant_id][item.properties['_Item Price']] += item.quantity;
    }
  }
  addons = (Object.keys(addons).length > 0) ? addons : false;
  return addons;
}

function cartNeedsUpdating() {
  var currentAddOns = getCurrentAddOns();
  if (cart.length == 0 && Object.keys(currentAddOns).length > 0) {
    return true;
  }
  for (var i = 0; i < cart.length; i++) {
    var item = cart[i];
    if (isItemAddOn(item) || !isset(item.properties)) {
      continue;
    }
    if (!isset(item.properties['_Item Price'])
      || (isset(item.properties['_Item Price'])
        && cartItems[item.variant_id].priceCalculated
        && item.properties['_Item Price'].toString() != cartItems[item.variant_id].priceCalculated.toString()
      )
    ) {
      return true;
    }
    var overlamPrice = isset(cartItems[item.variant_id].overlamination) ? cartItems[item.variant_id].overlamination : 0;
    if (isset(item.properties) && isset(item.properties['Overlamination']) && item.properties['Overlamination'] == "Yes" && overlamPrice && overlamPrice > 0) {
      if (!isset(currentAddOns[overlamVariantId])
        || !isset(currentAddOns[overlamVariantId][overlamPrice])
        || (isset(currentAddOns[overlamVariantId][overlamPrice]) && currentAddOns[overlamVariantId][overlamPrice] < item.quantity)
      ) {
        return true;
      }
      currentAddOns[overlamVariantId][overlamPrice] -= item.quantity;
    }
    var foilPrice = isset(cartItems[item.variant_id].foil_stamping) ? cartItems[item.variant_id].foil_stamping : 0;
    if (isset(item.properties) && isset(item.properties['Foil Stamping']) && item.properties['Foil Stamping'] == "Yes" && foilPrice && foilPrice > 0) {
      if (!isset(currentAddOns[foilVariantId])
        || !isset(currentAddOns[foilVariantId][foilPrice])
        || (isset(currentAddOns[foilVariantId][foilPrice]) && currentAddOns[foilVariantId][foilPrice] < item.quantity)
      ) {
        return true;
      }
      currentAddOns[foilVariantId][foilPrice] -= item.quantity;
    }
    var numberingPrice = isset(cartItems[item.variant_id].numbering) ? cartItems[item.variant_id].numbering : 0;
    if (isset(item.properties) && isset(item.properties['_Numbering']) && item.properties['_Numbering'] == "Yes" && numberingPrice && numberingPrice > 0) {
      if (!isset(currentAddOns[numberingVariantId])
        || !isset(currentAddOns[numberingVariantId][numberingPrice])
        || (isset(currentAddOns[numberingVariantId][numberingPrice]) && currentAddOns[numberingVariantId][numberingPrice] < item.quantity)
      ) {
        return true;
      }
      currentAddOns[numberingVariantId][numberingPrice] -= item.quantity;
    }
    var mattePrice = isset(cartItems[item.variant_id].matte) ? cartItems[item.variant_id].matte : 0;
    if (isset(item.properties) && isset(item.properties['Matte Varnish']) && item.properties['Matte Varnish'] == "Yes" && mattePrice && mattePrice > 0) {
      if (!isset(currentAddOns[matteVariantId])
        || !isset(currentAddOns[matteVariantId][mattePrice])
        || (isset(currentAddOns[matteVariantId][mattePrice]) && currentAddOns[matteVariantId][mattePrice] < item.quantity)
      ) {
        return true;
      }
      currentAddOns[matteVariantId][mattePrice] -= item.quantity;
    }
  };
  var allAddOnsAccountedFor = true;
  Object.keys(currentAddOns).forEach(function (variant_id) {
    var addOnPrices = currentAddOns[variant_id];
    Object.keys(addOnPrices).forEach(function (price) {
      if (addOnPrices[price] > 0) {
        allAddOnsAccountedFor = false;
      }
    });
  });
  if (!allAddOnsAccountedFor) {
    return true;
  }
  return false;
}

function mergeCartItems(updateQty) {
  if (!isset(updateQty)) {
    updateQty = {};
  }
  var newCart = [];
  var addOns = [];
  cart.forEach(function (item) {
    if (isItemAddOn(item)) {
      return;
    }
    var qty = item.quantity;
    var options_with_values = item.options_with_values;
    if (isset(updateQty[item.key])) {
      qty = updateQty[item.key];
    }

    if (item.properties._quantity_step_metafield) {
      const step = item.properties._quantity_step_metafield;
      const value = parseFloat(qty);
      if (!isNaN(value)) {
        qty = Math.round(value / step) * step;
      }
    }

    var variant_id = item.variant_id;
    var currentProps = {};

    Object.keys(item.properties).forEach((key) => {


      if (!key.startsWith('_')) {
        if (key !== 'Size' && key !== 'Material') {
          currentProps[`_${key}`] = item.properties[key];
        } else {
          currentProps[`${key}`] = item.properties[key];
        }

      }
      if (key.startsWith('_')) {
        currentProps[`${key}`] = item.properties[key];
      }
    });
    // if(isset(item.properties) && isset(item.properties["_Item Price"])){
    //   delete item.properties["_Item Price"];
    // }
    // if(isset(currentProps) && isset(currentProps["_Item Price"])){
    //   delete currentProps["_Item Price"];
    // }
    var foundInNewCart = false;
    newCart.forEach(function (newItem, idx) {
      const properties = {}
      Object.keys(newItem.properties).forEach((key) => {
        if (!key.startsWith('_')) {
          if (key !== 'Size' && key !== 'Material') {
            properties[`_${key}`] = newItem.properties[key];
          } else {
            properties[`${key}`] = newItem.properties[key];
          }

        }
        if (key.startsWith('_')) {
          properties[`${key}`] = newItem.properties[key];
        }
      });
      if (isset(properties["_Custom Size"])) {
        delete properties["Size"];
      }
      newItem.properties = properties;

      if (newItem.id == variant_id && isObjectEqual(currentProps, newItem.properties)) {
        newCart[idx].quantity += qty;
        newCart[idx].options_with_values = options_with_values;
        foundInNewCart = true;
      }
    });
    if (!foundInNewCart) {
      newCart.push({
        //         ...item,
        id: variant_id,
        quantity: qty,
        properties: currentProps,
      });
    }
  });
  newCart.forEach(function (newItem, idx) {
    if (isset(cartItems[newItem.id])) {
      var cartItem = cartItems[newItem.id];
      if (isset(newItem.properties) && isset(newItem.properties['Overlamination']) && newItem.properties['Overlamination'] == "Yes" && cartItem.overlamination && cartItem.overlamination > 0) {
        var foundInAddOnCart = false;
        var currentProps = {
          "_Item Price": cartItem.overlamination,
        };
        addOns.forEach(function (addOnItem, addOnIdx) {
          if (addOnItem.id == overlamVariantId && isObjectEqual(currentProps, addOnItem.properties)) {
            addOns[addOnIdx].quantity += parseInt(newItem.quantity);
            foundInAddOnCart = true;
          }
        });
        if (!foundInAddOnCart) {
          addOns.push({
            id: overlamVariantId,
            quantity: parseInt(newItem.quantity),
            properties: currentProps
          });
        }
      }
      if (isset(newItem.properties) && isset(newItem.properties['Foil Stamping']) && newItem.properties['Foil Stamping'] == "Yes" && cartItem.foil_stamping && cartItem.foil_stamping > 0) {

        var foundInAddOnCart = false;
        var currentProps = {
          "_Item Price": cartItem.foil_stamping,
        };
        addOns.forEach(function (addOnItem, addOnIdx) {
          if (addOnItem.id == foilVariantId && isObjectEqual(currentProps, addOnItem.properties)) {
            addOns[addOnIdx].quantity += parseInt(newItem.quantity);
            foundInAddOnCart = true;
          }
        });
        if (!foundInAddOnCart) {
          addOns.push({
            id: foilVariantId,
            quantity: parseInt(newItem.quantity),
            properties: currentProps
          });
        }

      }
      if (isset(newItem.properties) && isset(newItem.properties['Numbering']) && newItem.properties['Numbering'] == "Yes" && cartItem.numbering && cartItem.numbering > 0) {

        var foundInAddOnCart = false;
        var currentProps = {
          "_Item Price": cartItem.numbering,
        };
        addOns.forEach(function (addOnItem, addOnIdx) {
          if (addOnItem.id == numberingVariantId && isObjectEqual(currentProps, addOnItem.properties)) {
            addOns[addOnIdx].quantity += parseInt(newItem.quantity);
            foundInAddOnCart = true;
          }
        });
        if (!foundInAddOnCart) {
          addOns.push({
            id: numberingVariantId,
            quantity: parseInt(newItem.quantity),
            properties: currentProps
          });
        }

      }
      if (isset(newItem.properties) && isset(newItem.properties['Matte Varnish']) && newItem.properties['Matte Varnish'] == "Yes" && cartItem.matte && cartItem.matte > 0) {

        var foundInAddOnCart = false;
        var currentProps = {
          "_Item Price": cartItem.matte,
        };
        addOns.forEach(function (addOnItem, addOnIdx) {
          if (addOnItem.id == matteVariantId && isObjectEqual(currentProps, addOnItem.properties)) {
            addOns[addOnIdx].quantity += parseInt(newItem.quantity);
            foundInAddOnCart = true;
          }
        });
        if (!foundInAddOnCart) {
          addOns.push({
            id: matteVariantId,
            quantity: parseInt(newItem.quantity),
            properties: currentProps
          });
        }

      }
      if (!isset(newCart[idx].properties)) {
        newCart[idx].properties = {};
      }
      newCart[idx].properties['_Item Price'] = cartItem.priceCalculated;
    }
  });
  $.merge(newCart, addOns);
  return newCart;
}

async function doAjax(url, params = {}, method = 'POST') {
  return $.ajax({
    url: url,
    type: method,
    dataType: 'json',
    data: params
  });
}
async function regenerateCart(newCart) {
  if (!newCart.length) {
    return false;
  }
  //   createCartHtml(newCart);
  // clearing the cart
  var cartClear = await doAjax('/cart/clear.js', {}, "POST");
  var cartCreated = await doAjax('/cart/add.js', { items: newCart }, "POST");
  refreshCart();
  // $.ajax({ // clearing the cart
  //   type    : "POST",
  //   url     : '/cart/clear.js',
  //   dataType  : 'json',
  //   success : function(){
  //     $.ajax({ // adding merged items to the cart
  //       type    : "POST",
  //       url     : '/cart/add.js',
  //       data    : {items : newCart},
  //       dataType  : 'json',
  //       success : function(){
  //         console.log('reloading after cart recreate');
  //         refreshCart();
  //         //window.location.reload();
  //       },
  //     });
  //   },
  // });
}

async function clearCart() {
  await doAjax('/cart/clear.js', {}, "POST");
  createCartHtml();
  //   $.ajax({ // clearing the cart
  //     type    : "POST",
  //     url     : '/cart/clear.js',
  //     dataType  : 'json',
  //     success : function(){
  //       console.log('reloading after cart clear');
  //       createCartHtml();
  // //       window.location.reload();
  //     },
  //   });
}

function checkAllCartItems() {
  var allDone = true;
  Object.keys(cartItems).forEach(function (variantId) {
    if (!cartItems[variantId]['priceCalculated'] && !cartItems[variantId]['sku'].includes('Sample-Pack')) {
      allDone = false;
    }
  });
  if (allDone) {
    if (cartNeedsUpdating()) {
      var newCart = mergeCartItems();
      regenerateCart(newCart);
      return;
    }
    finalProcessing();
    const zeroPad = (num, places) => String(num).padStart(places, '0');
    cart.map(item => {
      if (item.properties['parking-permit-starting-number']) {
        let ParkingPermitPreview = `${item.properties['parking-permit-prefix']}${zeroPad(item.properties['parking-permit-starting-number'], document.querySelector(`.cart_item_qty_select[data-key="${item.key}"]`).getAttribute('data-qty').length)}`;
        document.querySelector(`#parking-permit-cart-preview[data-id="${item.key}"]`).innerText = ParkingPermitPreview;
      }

    });
    initiateCartReviewDesign();
  } else {
    fireKlaviyoCartEvent();
  }
}

function calculatePricingForCart(variantId) {
  var item = cartItems[variantId];
  var minLotQty = Object.keys(cartItems[variantId].priceObject.prices)[0];
  var product_id = cartItems[variantId].product_id;
  var qty = item['qty'];
  var minimumCustomQty = localStorage.getItem('minimumCustomQty') ? JSON.parse(localStorage.getItem('minimumCustomQty'))[product_id] : null;
  var basePrice = item['basePrice'];
  if (item['priceObject']) {
    var discountedPrice = getDiscountedPrice(item['qty'], item['priceObject'], 'prices', item._lot_pricing);
    discountedPrice = discountedPrice.toFixed(2);
    if (discountedPrice <= 0) {
      discountedPrice = basePrice;
    }
    cartItems[variantId]['priceCalculated'] = qty < minLotQty ? (1 * ((minLotQty * discountedPrice) / qty).toFixed(2)) : (1 * discountedPrice);
    if (item['overlaminationQty'] > 0) {
      cartItems[variantId]['overlamination'] = (1 * getDiscountedPrice(item['overlaminationQty'], item['priceObject'], 'overlamination', item._lot_pricing));
    } else {
      cartItems[variantId]['overlamination'] = 0;
    }
    if (item['foilStampingQty'] > 0) {
      cartItems[variantId]['foil_stamping'] = (1 * getDiscountedPrice(item['foilStampingQty'], item['priceObject'], 'foil', item._lot_pricing));
    } else {
      cartItems[variantId]['foil_stamping'] = 0;
    }
    if (item['numberingQty'] > 0) {
      cartItems[variantId]['numbering'] = (1 * getDiscountedPrice(item['numberingQty'], item['priceObject'], 'numbering', item._lot_pricing));
    } else {
      cartItems[variantId]['numbering'] = 0;
    }
    if (item['matteQty'] > 0) {
      cartItems[variantId]['matte'] = (1 * getDiscountedPrice(item['matteQty'], item['priceObject'], 'matte', item._lot_pricing));
    } else {
      cartItems[variantId]['matte'] = 0;
    }
  } else {
    cartItems[variantId]['priceCalculated'] = basePrice;
    cartItems[variantId]['overlamination'] = 0;
    cartItems[variantId]['foil_stamping'] = 0;
    cartItems[variantId]['numbering'] = 0;
    cartItems[variantId]['matte'] = 0;
  }


}
function toFixed(number, decimals) {
  const x = Math.pow(10, Number(decimals) + 2);
  return (Number(number) + (1 / x)).toFixed(decimals)
}
function updateCartSubmit(donotValidate) {
  displayLoader(true);
  setTimeout(function () {
    donotValidate = isset(donotValidate) ? donotValidate : false;
    var updateQty = {};
    var error = false;
    $('.cart_item_custom_qty').removeClass('error').css('border-color', 'inherit');
    $('.cart_total_btn_checkout').removeClass('cart-item-error');
    if (!donotValidate) {
      var errorMsgs = {};
      $('.cart_item_custom_qty').each(function () {
        var $ele = $(this);
        var totalVariantQty = 0;
        var variantId = $(this).data('id');
        $('.cart_item_custom_qty[data-id=' + variantId + ']').each(function () {
          totalVariantQty += parseInt($(this).val());
        });
        if (isset(cartItems[variantId]) && typeof (cartItems[variantId].priceObject) == "object") {
          var minQty = Object.keys(cartItems[variantId].priceObject.prices)[0];
          debugger;
          var product_id = cartItems[variantId].product_id;
          var minimumCustomQty = localStorage.getItem('minimumCustomQty') ? JSON.parse(localStorage.getItem('minimumCustomQty'))[product_id] : null;
          if (minimumCustomQty) {
            if (totalVariantQty < minimumCustomQty) {
              $('.cart_item_custom_qty[data-id=' + variantId + ']').addClass('error').css('border-color', '#f00');
              errorMsgs[variantId] = "Minimum custom quantity for this product is " + minimumCustomQty + ". Add " + (minimumCustomQty - totalVariantQty) + " more.";
              error = true;
            }
          } else {
            if (totalVariantQty < minQty) {
              $('.cart_item_custom_qty[data-id=' + variantId + ']').addClass('error').css('border-color', '#f00');
              errorMsgs[variantId] = "Minimum order quantity for this product is " + minQty + ". Add " + (minQty - totalVariantQty) + " more.";
              error = true;
            } else if (parseInt($(this).val()) < minQty) {
              $(this).addClass('error').css('border-color', '#f00');
              errorMsgs[variantId] = "Minimum order quantity for this product is " + minQty + ". Add " + (minQty - $(this).val()) + " more.";
              error = true;
            }
          }
        }
      });
      if (error) {
        errorMsgs = Object.keys(errorMsgs).map(function (variantId) {
          return errorMsgs[variantId];
        }).join('\n');
        alert(errorMsgs);
        $('.cart_total_btn_checkout').addClass('cart-item-error');
        displayLoader(false);
        return false;
      } else {
        $('.cart_total_btn_checkout').removeClass('cart-item-error');
      }
    }
    $('.cart_item_custom_qty').each(function () {
      updateQty[$(this).data('key')] = parseInt($(this).val());
    });
    var newCart = mergeCartItems(updateQty);
    regenerateCart(newCart);
  }, 100);
  fireKlaviyoCartEvent();
}

function finalProcessing() {
  var total = 0;
  cart.map(item => {
    if (isItemAddOn(item)) {
      return;
    }
    /* Displayed line item price - start */
    var variantId = item.id;
    var cartProduct = cartItems[variantId];
    var itemPrice = item.final_price / 100;
    var overlamPrice = 0;
    var foilPrice = 0;
    var numberingPrice = 0;
    var mattePrice = 0;
    var minQty = Object.keys(cartItems[variantId].priceObject.prices)[0];
    var product_id = cartItems[variantId].product_id;
    var qty = cartProduct['qty'];
    var minimumCustomQty = localStorage.getItem('minimumCustomQty') ? JSON.parse(localStorage.getItem('minimumCustomQty'))[product_id] : null;
    if (isset(cartItems[variantId]['priceCalculated']) && cartItems[variantId]['priceCalculated'] > 0) {
      itemPrice = cartItems[variantId]['priceCalculated'];
    }
    if (isset(item.properties) && isset(item.properties['Overlamination']) && item.properties['Overlamination'] == "Yes") {
      overlamPrice = cartItems[variantId]['overlamination'];
    }
    if (isset(item.properties) && isset(item.properties['Foil Stamping']) && item.properties['Foil Stamping'] == "Yes") {
      foilPrice = cartItems[variantId]['foil_stamping'];
    }
    if (isset(item.properties) && isset(item.properties['Numbering']) && item.properties['Numbering'] == "Yes") {
      numberingPrice = cartItems[variantId]['numbering'];
    }
    if (isset(item.properties) && isset(item.properties['Matte Varnish']) && item.properties['Matte Varnish'] == "Yes") {
      mattePrice = cartItems[variantId]['matte'];
    }
    var unitPrice = itemPrice + overlamPrice + foilPrice + numberingPrice + mattePrice;
    var finalAmt = unitPrice * item.quantity;
    unitPrice = toFixed(unitPrice, 2);
    total += finalAmt;
    finalAmt = Math.round(finalAmt * 100) / 100;
    $('.cart_item_total[data-key="' + item.key + '"]').html("$" + (finalAmt).toFixed(2));
    /* Displayed line item price - end */
  });

  $('.cart_total_subtotal .amount').html("$" + (total).toFixed(2));

  /* dropdown setup - start */
  $('.cart_item_qty_select').each(function () {
    var varId = $(this).attr('data-id');
    if (isset(cartItems[varId])) {
      setQtyOptions(cartItems[varId].priceObject, $(this), cartItems[varId]._lot_pricing, cartItems[varId].qty);
    }
    if (
      $(this).find('option').length == 0
      || ($(this).find('option').length == 1 && $(this).find('option').first().attr('value') == 'custom')
    ) {
      $(this).parents('.select-quantity').addClass('hide-select');
    } else {
      $(this).parents('.select-quantity').removeClass('hide-select');
    }
    if ($(this).find('option[value="' + $(this).parent().next('input.cart_item_custom_qty').val() + '"]').length) {
      $(this).val($(this).parent().next('input.cart_item_custom_qty').val());
      $(this).parent().next('input.cart_item_custom_qty').attr('type', 'hidden');
    } else if ($(this).find('option[value="custom"]').length) {
      $(this).val('custom');
      $(this).parent().next('input.cart_item_custom_qty').attr('type', 'number');
    }
  });
  /* dropdown setup - end */

  let timerId;

  function debounce(func, delay) {
    return function () {
      clearTimeout(timerId);
      timerId = setTimeout(func, delay);
    }
  }

  $('.select-quantity input').off('change').on('change', debounce(function () {
    updateCartSubmit();
  }, 500));
  $('.cart_item_close a').off('click').on('click', function (e) {
    e.preventDefault();
    var key = $(this).data('key');
    $('.cart_item_custom_qty[data-key="' + key + '"]').val(0);
    updateCartSubmit(true);
  });

  displayLoader(false);
}

function getCartQty(variantId, type) {
  type = typeof type != "undefined" ? type : 'product';
  let lineItems = [];
  if (type == 'product') {
    lineItems = cart.filter(item => item.id == variantId);
  } else if (type == 'overlamination') {
    lineItems = cart.filter(item => item.id == variantId && isset(item.properties) && isset(item.properties['Overlamination']) && item.properties['Overlamination'] == "Yes");
  } else if (type == 'foil_stamping') {
    lineItems = cart.filter(item => item.id == variantId && isset(item.properties) && isset(item.properties['Foil Stamping']) && item.properties['Foil Stamping'] == "Yes");
  } else if (type == 'numbering') {
    lineItems = cart.filter(item => item.id == variantId && isset(item.properties) && isset(item.properties['Numbering']) && item.properties['Numbering'] == "Yes");
  } else if (type == 'matte') {
    lineItems = cart.filter(item => item.id == variantId && isset(item.properties) && isset(item.properties['Matte Varnish']) && item.properties['Matte Varnish'] == "Yes");
  }
  let qty = 0;
  lineItems.map(item => qty += item.quantity);
  return qty;
}

async function generateCartItemsObject() {
  cartItems = {};
  if (cart != null) {
    for (let line_item of cart) {
      // cart.forEach(line_item => {
      var varId = line_item.variant_id;
      if (!isItemAddOn(line_item)) {
        var price_file_url = false;
        var _lot_pricing = false;
        if (typeof (cartItems[varId]) == "undefined") {
          cartItems[varId] = {
            'qty': 0,
            'overlaminationQty': 0,
            'foilStampingQty': 0,
            'numberingQty': 0,
            'matteQty': 0,
            'price_file_url': false,
            'priceObject': false,
            'priceCalculated': false,
            'basePrice': (line_item.original_price / 100),
            'sku': line_item.sku,
            'barcode': getBarcodeFromSku(line_item.sku),
          };
        }
        cartItems[varId]['product_id'] = line_item.product_id;
        cartItems[varId]['qty'] += line_item.quantity;
        Object.keys(line_item.properties).map(prop => {
          if (prop == "_lot_pricing") {
            _lot_pricing = line_item.properties["_lot_pricing"] == "true";
          }
          if (prop == "lot_pricing") {
            _lot_pricing = line_item.properties["_lot_pricing"] == "true";
          }
        });
        // console.log('line_item.properties', line_item.properties);
        if (!priceFileUrls[line_item.variant_id]) {
          const errorMessage = `Current product ${line_item.product_title} doesn't have the $= tag. Please check Shopify and include that tag to the product.`;
          if (window.location.origin === "https://stomp-stickers.myshopify.com") {
            alert(errorMessage);
          } else {
            console.log(errorMessage);
          }
        }
        cartItems[varId]['price_file_url'] = priceFileUrls[line_item.variant_id];
        cartItems[varId]['_lot_pricing'] = _lot_pricing;
        var line_item_price_file_url = cartItems[varId]['price_file_url'];
        if (!line_item_price_file_url) {
          calculatePricingForCart(varId);
        } else {
          var json = await $.getJSON(line_item_price_file_url);
          if (json) {
            validatePricingJson(json, line_item.handle, ({ isJsonValid, errorMessage }) => {
              if (!isJsonValid) {
                if (window.location.origin === "https://stomp-stickers.myshopify.com") {
                  alert(errorMessage);
                } else {
                  console.log(errorMessage);
                }
              }
            });
            var priceObject = getPricingObject(cartItems[varId]['barcode'], json);
            cartItems[varId]['priceObject'] = priceObject;
            if (priceObject) {
              cartItems[varId].qty = getCartQty(varId, 'product');
              cartItems[varId].overlaminationQty = getCartQty(varId, 'overlamination');
              cartItems[varId].foilStampingQty = getCartQty(varId, 'foil_stamping');
              cartItems[varId].numberingQty = getCartQty(varId, 'numbering');
              cartItems[varId].matteQty = getCartQty(varId, 'matte');
            }
          }
          if (!json) {
            const errorMessage = `JSON ajax failed. Please make sure the JSON file ${line_item_price_file_url} exists`;
            if (window.location.origin === "https://stomp-stickers.myshopify.com") {
              alert(errorMessage);
            } else {
              console.error(errorMessage);
            }
          }
          calculatePricingForCart(varId);
        }
      }
    }
    checkAllCartItems();
  }
}

/** Line item may use thumbnail / thumbnail2… or _thumbnail / _thumbnail2… (see cart.js). */
function getLineItemProofThumbUrl(properties, sideIndex) {
  if (sideIndex === 1) {
    return (properties && (properties._thumbnail || properties.thumbnail)) || false;
  }
  var s = String(sideIndex);
  return (properties && (properties['_thumbnail' + s] || properties['thumbnail' + s])) || false;
}

function createCartHtml(cart) {
  function isDieCutFamilyItem(item) {
    const normalizedTitle = String(item.product_title || '').toLowerCase();
    const normalizedType = String(item.product_type || '').toLowerCase();
    const normalizedUrl = String(item.url || '').toLowerCase();
    const haystack = `${normalizedTitle} ${normalizedType} ${normalizedUrl}`;
    return haystack.includes('die cut') || haystack.includes('die-cut') || haystack.includes('diecut');
  }

  var html = [];
  if (cart && $.isArray(cart)) {
    html = cart.map(item => {
      if (isItemAddOn(item)) {
        return;
      }
      var size_found = false;
      var properties = item.properties;
      if (isset(properties["_Custom Size"])) {
        delete properties["Size"];
      }
      var thumb_found = getLineItemProofThumbUrl(properties, 1);
      var thumb_found2 = getLineItemProofThumbUrl(properties, 2);
      var thumb_found3 = getLineItemProofThumbUrl(properties, 3);
      var thumb_found4 = getLineItemProofThumbUrl(properties, 4);
      var props = Object.keys(properties).map(property => {
        if (property == "_Custom Size") {
          size_found = "<li>Size: " + item.properties[property] + "</li>";
          item.options_with_values.forEach(option => {
            if (option.name === 'Size') {
              option.value = item.properties[property];
            }
          })
          return;
        }
        if (property == "_Sides") {
          size_found = "<li>Sides: " + item.properties[property] + "</li>";
          item.options_with_values.forEach(option => {
            if (option.name === 'Sides') {
              option.value = item.properties[property];
            }
          })
          return;
        }
        if ($.inArray(property, showTheseProps) !== -1) {
          return "<li>" + property + ": " + item.properties[property] + "</li>";
        }
      });
      if (size_found !== false) {
        props.unshift(size_found);
      }
      var imgSrc = item.properties.thumbnail;
      var projectId = item.properties.project_id || item.properties._project_id || '';
      var hasDhProject = !!projectId;
      var isReorderItem = !!(
        item.properties.reorder_of ||
        item.properties._reorder_of
      );
      var showEditDesignButton = hasDhProject && !isReorderItem && !isDieCutFamilyItem(item);
      if (imgSrc && imgSrc.lastIndexOf('/') > imgSrc.lastIndexOf('.')) {
        imgSrc = imgSrc.substring(0, imgSrc.lastIndexOf('/'));
      }
      let quantityMessage = '';
      if (item.properties._quantity_step_metafield) {
        quantityMessage = `<p style="font-family: 'Chivo', sans-serif; font-weight: 700; font-size: 14px; text-transform: uppercase; padding-bottom: 16px;">${item.product_title} can only be ordered in multiples of ${item.properties._quantity_step_metafield}</p>`;
      }
      return `<ul class="cart_item_col">
                        <li class="cart_item_desc_col">
                          <p class="cart_item_image">
                              <a href="${item.url}">  
                                  <img src="${thumb_found ? thumb_found : isset(item.featured_image) && item.featured_image.url != null ? item.featured_image.url : noImage}" onerror="this.src='${imgSrc}'" alt="${htmlEntities(isset(item.featured_image) && item.featured_image.alt != null ? item.featured_image.alt : item.product_title)}">
                              </a>
                          </p>
                          <ul class="cart_item_info">
                              <li class="cart_item_info_title"><a href="${item.url}">${item.product_title}</a></li>
                              ${props.join("")}
                              ${item.properties['parking-permit-prefix'] && item.properties['Numbering'] == 'With Numbering' ? '<li>Prefix (ex. A): ' + item.properties['parking-permit-prefix'] + '</li>' : ''}
                              ${item.properties['parking-permit-starting-number'] && item.properties['Numbering'] == 'With Numbering' ? '<li>Starting #: ' + item.properties['parking-permit-starting-number'] + '</li>' : ''}
                              ${item.properties['parking-permit-starting-number'] && item.properties['Numbering'] == 'With Numbering' ? '<li>Preview: <span id="parking-permit-cart-preview" data-id="' + item.key + '">' + item.properties['parking-permit-preview'] + '</span></li>' : ''}
                              <button type="button" class="cart-review-design-button">Review Design</button>
                              ${showEditDesignButton ? `<button type="button" class="cart-edit-design-button${window.customerId ? '' : ' pending-validation'}" data-project-id="${projectId}" data-item-key="${item.key}" ${window.customerId ? '' : 'style=\"display:none;\"'}>Edit Design</button>` : ''}
                          </ul>
                        </li>
                        <li class="cart_item_qty_col">
                            <label for="validationOptions"></label>
                            <div class="cart_item_qty select-quantity">
                <div class="select-caret-wrapper">
                            <span class="caret"></span>
                                <select class="cart_item_qty_select" data-qty="${item.quantity}" min="0" data-id="${item.id}" data-key="${item.key}">
                                </select>
                </div>
                                <input type="text" value="${item.quantity}" min="0" data-id="${item.id}" data-key="${item.key}"  data-quantity-step="${item.properties['_quantity_step_metafield']}" class="cart_item_custom_qty">
                            </div>
                        </li>
                        <li class="cart_item_total_col"><span class="cart_item_total" data-key="${item.key}">${isset(item.line_price) ? "$" + (item.final_line_price / 100).toFixed(2) : ""}</span></li>
                        <li class="cart_item_close_col"><span class="cart_item_close"><a href="javascript:void(0);" data-key="${item.key}" ><img src="${cartItemRemoveIcon}"></a></span></li>
                    </ul>
                    ${quantityMessage}
                    <div class="canvas-approval-overlay">
                      <div class="canvas-approval-inner">
                        <div class="canvas-approval-inner-wrapper">
                          <div class="canvas-approval-header canvas-approval-header__mobile">
                            <p>Instant Proof</p>
                          </div>
                          <div id="canvas-approval-proof"  style="background-color:#FFFFFF;" >
                            <img id="canvas-approval-proof-image-one" src="${thumb_found ? thumb_found : isset(item.featured_image) && item.featured_image.url != null ? item.featured_image.url : noImage}" alt="Your Proof"/>
                            <img id="canvas-approval-proof-image-two" src="${thumb_found2 ? thumb_found2 : noImage}" style="${thumb_found2 ? 'display: flex;' : ''} " alt="Your Proof 2"/>
                            <img id="canvas-approval-proof-image-three" src="${thumb_found3 ? thumb_found3 : noImage}" style="${thumb_found3 ? 'display: flex;' : ''} " alt="Your Proof 3"/>
                            <img id="canvas-approval-proof-image-four" src="${thumb_found4 ? thumb_found4 : noImage}" style="${thumb_found4 ? 'display: flex;' : ''} " alt="Your Proof 4"/>
                            <p>Not shown at actual size</p>
                          </div>
                          <div id="canvas-approval-body">
                            <div class="canvas-approval-header canvas-approval-header__desktop">
                              <p>Instant Proof</p>
                            </div>
                            <p id="canvas-approval-product">${item.product_title}</p>
                            <ul>
                              ${props.join("")}
                            </ul>
                            <p id="canvas-approval-size"></p>
                            <div id="canvas-approval-button-wrapper">
                              <button type="button" id="cart-close-design-review" class="btn btn-primary d-block mt-1 cart-close-design-review">Back to Cart</button>
                            </div>
                          </div>
                          <span class="canvas-approval-close-cart" id="canvas-approval-close-cart">&#x2573</span>
                        </div>
                      </div>
                    </div>`;
    });
    $('.cart_total, .order_notes, .cart-icon .count').show();
    if ($(window).width() > 767) {
      $('.cart_item_title').show();
    }
  }
  if (html.length == 0) {
    html.push(`<div class="empty-cart-message">
                        <p>Your cart is currently empty.</p>
                        <div class="empty-cart-message-actions">
                          <p><a href="/collections/all" class="btn_c">CONTINUE SHOPPING</a></p>
                          ${window.customerId ? `<p><a href="/account?tab=3" class="btn_c">View my saved artwork</a></p>` : `<p><a href="/account/login" class="btn_c">Login to view saved artwork</a></p>`}
                        </div>
                      </div>`);
    $('.cart_item_title, .cart_total, .order_notes, .cart-icon .count').hide();
    displayLoader(false);
  }
  $('#cart_line_items').html(html.join(""));
  generateCartItemsObject();
}

async function refreshCart() {
  $.ajax({ // clearing the cart
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    success: function (fetchedCart) {
      if (!isset(fetchedCart.items)) {
        cart = cartList = false;
      } else {
        cart = cartList = fetchedCart.items;
      }
      createCartHtml(cartList);
    },
  });
}
/******** cart specific functions ***end***/

window.addEventListener('load', (event) => {
  if (isset(page) && page == "cart") {
    /* Runs on cart page only */
    displayLoader(true);
    if (window.customerId && window.customerEmail && window.designHuddleTokenAPIUrl) {
  $.ajax({
    url: window.designHuddleTokenAPIUrl, type: 'POST', crossDomain: true,
    xhrFields: { withCredentials: true }, contentType: 'application/json',
    headers: { 'Accept': 'application/json', 'x-username': window.customerEmail, 'x-guest_code': localStorage.getItem('guest_code') },
    data: JSON.stringify({ grant_type: 'password', username: window.customerEmail, guest_code: localStorage.getItem('guest_code') })
  }).done(function (r) {
    (window.ccRemapCartProjectIds ? window.ccRemapCartProjectIds(r.access_token) : Promise.resolve(false))
      .then(function () { refreshCart(); });
  }).fail(function () { refreshCart(); });
} else {
  refreshCart();
}
    fireKlaviyoCartEvent();
    // createCartHtml(cart);
    $('#cartform').submit(function (e) {
      e.preventDefault();
      // updateCartSubmit();
    });
    fireKlaviyoCartEvent();
    initiateCartReviewDesign()
  }
});

const initiateCartReviewDesign = () => {
  if (document.getElementById('canvas-approval-close-cart')) {
    document.querySelectorAll('.canvas-approval-close-cart').forEach(element => {
      $(element).off('click').on('click', function () {
        element.closest('.canvas-approval-overlay').classList.remove('open');
      });
    });
  }
  if (document.getElementById('cart-close-design-review')) {
    document.querySelectorAll('.cart-close-design-review').forEach(element => {
      $(element).off('click').on('click', function () {
        element.closest('.canvas-approval-overlay').classList.remove('open');
      });
    });
  }
  if (document.querySelectorAll('.cart-review-design-button')) {
    document.querySelectorAll('.cart-review-design-button').forEach(element => {
      $(element).off('click').on('click', function () {
        if (element.closest('.cart_item_col').nextElementSibling.classList.value.includes('canvas-approval-overlay')) {
          element.closest('.cart_item_col').nextElementSibling.classList.add('open');
        } else {
          element.closest('.cart_item_col').nextElementSibling.nextElementSibling.classList.add('open');
        }
      });
    });
  }
  if (document.querySelectorAll('.cart-edit-design-button')) {
    document.querySelectorAll('.cart-edit-design-button').forEach(element => {
      $(element).off('click').on('click', function () {
        const itemKey = element.getAttribute('data-item-key');
        const itemToEdit = Array.isArray(cartList) ? cartList.find(item => item.key === itemKey) : null;
        if (!itemToEdit || !itemToEdit.properties) {
          return;
        }
        const getProp = function (name) {
          return itemToEdit.properties[name] || itemToEdit.properties[`_${name}`] || '';
        };
        const storageData = {
          cc_state_id: getProp('customer_canvas_state'),
          project_id: getProp('project_id'),
          project_token: getProp('project_token'),
          cart_item_key: itemToEdit.key,
          original_line_properties: Object.assign({}, itemToEdit.properties || {}),
          custom_size: !!getProp('Custom Size'),
          product_id: parseFloat(itemToEdit.id),
          variant_id: itemToEdit.variant_id || itemToEdit.id,
          quantity: parseInt(itemToEdit.quantity),
          size: $($.parseHTML(getProp('Custom Size') || getProp('Size'))).text(),
          thumbnail: getProp('thumbnail'),
          product_handle: (itemToEdit.url || '').replace(/^\/products\//, '').split('?')[0],
          _source: 'customers_canvas',
          status_token: (getProp('project_id')) + '-' + Date.now(),
        };
        const savedArtworkKey = String(getProp('saved_artwork_key') || '').trim();
        const savedArtworkSource = String(getProp('saved_artwork_source') || '').trim();
        const isFromSavedArtworkEdit = String(getProp('from_saved_artwork_edit') || '').toLowerCase() === 'true';
        if (savedArtworkKey || isFromSavedArtworkEdit) {
          storageData.from_saved_artwork_edit = true;
          storageData.metafield_id = savedArtworkKey;
          storageData.saved_artwork_key = savedArtworkKey;
          storageData._source = savedArtworkSource || 'design_huddle';
          storageData.source = storageData._source;
          storageData.metadata = Object.assign({}, storageData.metadata || {}, {
            metafield_id: savedArtworkKey
          });
        }
        if (getProp('border')) {
          storageData.border = getProp('border');
        }
        if (getProp('cloudinary_url')) {
          storageData.cloudinary_url = getProp('cloudinary_url');
        }
        if (getProp('Material')) {
          storageData.material = getProp('Material');
        }
        if (getProp('Sides')) {
          storageData.sides = getProp('Sides');
        }
        window.localStorage.setItem('customers_canvas', JSON.stringify(storageData));
        window.location.href = itemToEdit.url;
      });
    });
  }
  validateGuestEditDesignButtons();
}

function validateGuestEditDesignButtons() {
  // Only validate for guests; logged in users already see the button
  if (window.customerId) return;
  const buttons = Array.from(document.querySelectorAll('.cart-edit-design-button.pending-validation'));
  if (!buttons.length) return;

  // If SDK already loaded, validate now; otherwise wait for script load
  const runValidation = function () {
    try {
      // Fetch a fresh DH token (no storage)
      const tokenUrl = window.designHuddleTokenAPIUrl || "";
      if (!tokenUrl || tokenUrl === '' || tokenUrl === 'undefined') {
        console.warn('[Cart Edit] Missing designHuddleTokenAPIUrl; cannot validate projects.');
        return;
      }
      const guestCode = typeof getValidDhGuestCode === 'function' ? getValidDhGuestCode() : '';
      if (!guestCode) {
        console.warn('[Cart Edit] Skipping validation: no guest id');
        return;
      }
      const username = guestCode;
      $.ajax({
        url: tokenUrl,
        type: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-username': username
        },
        crossDomain: true,
        xhrFields: { withCredentials: true },
        contentType: 'application/json',
        data: JSON.stringify({
          grant_type: 'password',
          username: username
        })
      }).done(function (resp) {
        if (resp && resp.access_token) {
          window.dhToken = resp.access_token;
          if (window.DSHDLib && typeof window.DSHDLib.configure === 'function') {
            window.DSHDLib.configure({
              domain: "design.300s.app",
              access_token: window.dhToken,
              disable_mobile_fullscreen_behavior: true,
              gid_cookie_name: window.DH_GID_COOKIE_NAME || 'dshd-gid-dxh0zafqgw8sbersr3px'
            });
            validateButtonsWithToken();
          } else {
            console.warn('[Cart Edit] DH SDK not ready after token fetch');
          }
        } else {
          console.warn('[Cart Edit] Unable to fetch DH token for guest validation', resp);
        }
      }).fail(function (err) {
        console.error('[Cart Edit] Error fetching DH token', err);
      });
    } catch (e) {
      console.error('Error validating guest edit design buttons', e);
    }
  };

  function validateButtonsWithToken() {
    buttons.slice().forEach(function (btn) {
      // const projectId = btn.getAttribute('data-project-id');
      const projectId = btn.getAttribute('data-project-id');

      // If SDK not ready or no project id, keep hidden (only show after successful validation)
      if (!projectId || !window.DSHDLib || typeof window.DSHDLib.getProject !== 'function') {
        console.warn('[Cart Edit] Skipping validation (missing projectId or SDK)', { projectId, sdkReady: !!(window.DSHDLib && window.DSHDLib.getProject) });
        return;
      }
      window.DSHDLib.getProject(projectId, {}, { access_token: window.dhToken }, function (err, project) {
        if (err) {
          console.warn('[Cart Edit] getProject error', { projectId, err });
        }
        var projectFound = (!err && project && project.project_id);
        var notFound = err && (err.status === 404 || /not\\s*found/i.test(err.message || err.error || ''));
        if (projectFound) {
          btn.style.display = '';
          btn.classList.remove('pending-validation');
        } else if (notFound) {
          console.warn('[Cart Edit] Removing button, project not found', { projectId });
          btn.parentElement && btn.parentElement.removeChild(btn);
        } else {
          console.warn('[Cart Edit] Project validation failed; keeping button hidden', { projectId });
        }
      });
    });
  };

  if (window.DSHDLib && typeof window.DSHDLib.getProject === 'function') {
    runValidation();
    return;
  }

  // Listen for DH SDK script load
  document.addEventListener('DHSDKReady', runValidation, { once: true });
  // Fallback: attach to script tag load if present
  let dhScript = document.querySelector('script[src*="cdn.designhuddle.com/jssdk"]');
  if (dhScript) {
    if (!dhScript.dataset.dhListener) {
      dhScript.dataset.dhListener = '1';
      dhScript.addEventListener('load', () => {
        const event = new Event('DHSDKReady');
        document.dispatchEvent(event);
      }, { once: true });
    }
  }
  else {
    // If not present, inject the SDK now
    dhScript = document.createElement('script');
    dhScript.src = 'https://cdn.designhuddle.com/jssdk/v1/lib.min.js';
    dhScript.async = true;
    dhScript.dataset.dhListener = '1';
    dhScript.addEventListener('load', () => {
      const event = new Event('DHSDKReady');
      document.dispatchEvent(event);
    }, { once: true });
    document.head.appendChild(dhScript);
  }

  // Final fallback: short poll in case the SDK was loaded before listeners attached
  (function waitForDH(attempt) {
    if (window.DSHDLib && typeof window.DSHDLib.getProject === 'function') {
      runValidation();
      return;
    }
    if (attempt > 20) {
      console.warn('[Cart Edit] DH SDK not available after waiting; leaving Edit Design buttons hidden until SDK loads');
      return;
    }
    setTimeout(function () { waitForDH(attempt + 1); }, 150);
  })(0);
}
